"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const oxygen_config_1 = require("@8x8/oxygen-config");
const themeName_1 = __importDefault(require("../constants/themeName"));
const BadgeWrapper_1 = __importDefault(require("../styled/BadgeWrapper"));
const Badge = ({ children, ...passThroughProps }) => {
    const defaultProps = {
        ...passThroughProps,
        type: passThroughProps.type ?? 'primary',
        size: passThroughProps.size ?? 'medium',
        isInner: passThroughProps.isInner ?? false,
        testId: passThroughProps.testId ?? 'BADGE',
    };
    return react_1.default.createElement(BadgeWrapper_1.default, { ...defaultProps }, children);
};
Badge.displayName = 'Badge';
exports.default = (0, oxygen_config_1.withDeprecation)((0, oxygen_config_1.withTheme)(Badge, themeName_1.default), `The following items are deprecated:
    - "position: 'tl'" (use instead: "position: 'top-start'")
    - "position: 'tr'" (use instead: "position: 'top-end'")
    - "position: 'bl'" (use instead: "position: 'bottom-start'")
    - "position: 'br'" (use instead: "position: 'bottom-end'")
    - "type: secondary" (with novo this already renders the same as "primary")
    - "size: big" (with novo this already renders the same as "medium" which is the default)
  `);
